import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import { AddressDTO } from "@well/address-management-domain-model";

@Component({
  selector: 'well-address-line-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './address-line-view.component.html',
  styleUrls: ['./address-line-view.component.scss']
})
export class AddressLineViewComponent {

  @Input() companyName: string | null | undefined = null;

  @Input() address: AddressDTO | null | undefined = null;

}
